/**
 * Helpers for parsing the ID lead `status` array, which is shaped like:
 *   [{ "STATUS_KEY": "ISO_TIMESTAMP" }, ...]
 */

export const ID_ACK_EXPIRED = 'ID_ACKNOWLEDGEMENT_EXPIRED';
export const ID_ITER_ACK_EXPIRED = 'ID_ITERATION_ACKNOWLEDGEMENT_EXPIRED';
export const ID_DELIVERY_EXPIRED = 'ID_DESIGN_DELIVERY_EXPIRED';

/**
 * Parse the lead's `status` array into a sorted list of { key, timestamp }
 * entries. Invalid/malformed entries are skipped silently. Sorted by
 * timestamp ascending (oldest first).
 */
export const getStatusEntries = (lead) => {
  const raw = lead?.status;
  if (!Array.isArray(raw)) return [];
  const entries = raw
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null;
      const keys = Object.keys(entry);
      if (keys.length === 0) return null;
      const key = keys[0];
      const value = entry[key];
      const parsed = Date.parse(value);
      return {
        key,
        timestamp: value,
        timeMs: Number.isNaN(parsed) ? null : parsed,
      };
    })
    .filter(Boolean);
  // Stable ascending sort by parsed time; entries without time stay where they are.
  entries.sort((a, b) => {
    if (a.timeMs == null && b.timeMs == null) return 0;
    if (a.timeMs == null) return 1;
    if (b.timeMs == null) return -1;
    return a.timeMs - b.timeMs;
  });
  return entries.map(({ key, timestamp }) => ({ key, timestamp }));
};

/**
 * Returns true if the lead's status history contains the given key.
 */
export const hasStatus = (lead, key) => {
  if (!key) return false;
  return getStatusEntries(lead).some((entry) => entry.key === key);
};

/**
 * Returns the most recent status entry on the lead, or null.
 */
export const getLatestStatus = (lead) => {
  const entries = getStatusEntries(lead);
  if (entries.length === 0) return null;
  return entries[entries.length - 1];
};
